import { H2 } from "@blueprintjs/core";
import { setCurrentRoute, setPreviousRoute } from "controllers/common/action";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { constructPath, findRoute, routes } from "routes";
import { Analytics } from "utils/analytics";
import route from "./route";

export default function TechnicalReports() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentRoute(route));
    Analytics.getInstance().pageview(constructPath(findRoute(routes, route.id)));
    return () => dispatch(setPreviousRoute(route));
  });
  return (
    <div className="publications">
      <H2>Technical Reports</H2>

      <ol>
        <li id="ref-Baldu20_CEF" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1772558" target="_blank" rel="noreferrer">
            P. J. Balducci, K. Mongird, J. E. Alam, D. Wu, V. Fotedar, V. V. Viswanathan, A. J. Crawford, Y. Yuan, G.
            Labove, S. Richards, X. Shane, and K. Wallace, “Washington Clean Energy Fund grid modernization projects:
            Economic analysis (final report),” Pacific Northwest National Laboratory, Tech. Rep. PNNL-30594, Oct. 2020.
          </a>
        </li>
        <li id="ref-Baldu20_P2G" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1657345" target="_blank" rel="noreferrer">
            P. J. Balducci, D. Wu, T. Ramachandran, A. M. Campbell, V. Fotedar, K. Mongird, S. Huang et al.,
            “Power-to-Gas system valuation–final report,” Pacific Northwest National Laboratory, Tech. Rep.
            PNNL-ACT-10095, Jun. 2020.
          </a>
        </li>
        <li id="ref-Foted19_Hanscom" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1648190" target="_blank" rel="noreferrer">
            F. V., P. J. Balducci, W. M. Warwick, D. Wu, D. Wang, and K. Mongird, “Opportunities for dispatchable power
            projects in the new england independent system operator area,” Pacific Northwest National Laboratory, Tech.
            Rep. PNNL-29279, Oct. 2019.
          </a>
        </li>
        <li id="ref-Yuan19_HECO" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1648191" target="_blank" rel="noreferrer">
            Y. Y., P. J. Balducci, K. Mongird, V. Fotedar, D. Wu, and D. Bhatnagar, “Hawaiian electric companies demand
            response tool,” Pacific Northwest National Laboratory, Tech. Rep. PNNL-28956, Aug. 2019.
          </a>
        </li>
        <li id="ref-Baldu19_nantucket" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1564262" target="_blank" rel="noreferrer">
            P. J. Balducci, M. J. E. Alam, T. E. McDermott, V. Fotedar, X. Ma, D. Wu, B. A. Bhatti, K. Mongird, B. P.
            Bhattarai, A. J. Crawford, and S. Ganguli, “Nantucket Island energy storage system assessment,” Pacific
            Northwest National Laboratory, Tech. Rep. PNNL-28941, Aug. 2019.
          </a>
        </li>
        <li id="ref-WuD19_PEV" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1562254" target="_blank" rel="noreferrer">
            D. Wu, N. Radhakrishnan, X. Ke, S. Huang, A. P. Reiman, and K. Kalsi, “Coordinated PEV charging for
            distribution system management,” Pacific Northwest National Laboratory, Tech. Rep. PNNL-27710, Jul. 2019.
          </a>
        </li>
        <li id="ref-Crawf19_Avista" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1557266" target="_blank" rel="noreferrer">
            A. J. Crawford, V. V. Viswanathan, C. K. Vartanian, M. J. E. Alam, P. J. Balducci, D. Wu, T. D. Hardy, and
            K. Mongird, “Avista Turner energy storage system: Assessment of battery technical performance,” Pacific
            Northwest National Laboratory, Tech. Rep. PNNL-28480, Jul. 2019.
          </a>
        </li>
        <li id="ref-Crawf19_MESA2" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1545342" target="_blank" rel="noreferrer">
            A. Crawford, V. Viswanathan, M. J. Alam, P. J. Balducci, D. Wu, C. K. Vartanian, and K. Mongird, “Snohomish
            Public Utility District MESA 2: An assessment of flow battery energy storage system technical performance,”
            Pacific Northwest National Laboratory, Tech. Rep. PNNL-28478, Mar. 2019.
          </a>
        </li>
        <li id="ref-Viswa18_MESA1" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1474882" target="_blank" rel="noreferrer">
            V. Viswanathan, A. Crawford, J. Alam, P. Balducci, D. Wu, T. Hardy, and K. Mongird, “Snohomish Public
            Utility District MESA-1: An assessment of battery technical performance,” Pacific Northwest National
            Laboratory, Tech. Rep. PNNL-27237, Dec. 2018.
          </a>
        </li>
        <li id="ref-Mongi18_OPALCO" className="csl-entry" role="doc-biblioentry">
          <a href="https://doi.org/10.2172/1474882" target="_blank" rel="noreferrer">
            K. Mongird, P. Balducci, J. Alam, Y. Yuan, D. Wu, T. Hardy, J. Mietzner, T. Neal, R. Guerry, and J. Kimball,
            “Decatur island community solar and energy storage project–preliminary economic assessment,” Pacific
            Northwest National Laboratory, Tech. Rep. PNNL-27696, Jul. 2018. [Online].Available:
          </a>
          <a href="https://www.sandia.gov/ess-ssl/wp-content/uploads/2019/07/PNNL-Decatur-Island-Prel-Econ_July30_HRC.pdf">
            https://www.sandia.gov/ess-ssl/wp-content/uploads/2019/07/PNNL-Decatur-Island-Prel-Econ_July30_HRC.pdf
          </a>
        </li>
        <li id="ref-Baldu18_Shell" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1526319" target="_blank" rel="noreferrer">
            P. J. Balducci, K. Mongird, A. Somani, D. Wu, Y. Yuan, R. Fan, M. J. E. Alam, J. Steenkamp, and D.
            Bhatnagar, “Shell energy North America’s hydro battery system: Final market assessment report,” Pacific
            Northwest National Laboratory, Tech. Rep. PNNL-27620, Jun. 2018.
          </a>
        </li>
        <li id="ref-Baldu17_PGE" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1406263" target="_blank" rel="noreferrer">
            P. Balducci, J. Alam, V. V. Viswanathan, D. Wu, A. J. Crawford, K. Mongird, M. R. Weimar, A. Somani, and K.
            Whitener, “The Salem Smart Power Center: An assessment of battery performance and economic potential,”
            Pacific Northwest National Laboratory, Tech. Rep. PNNL-26858, Sep. 2017.
          </a>
        </li>
        <li id="ref-Viswa17_CEF_test" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1474881" target="_blank" rel="noreferrer">
            V. V. V., P. J. Balducci, M. E. Alam, A. J. Crawford, T. D. Hardy, and D. Wu, “Washington Clean Energy Fund:
            Energy storage system performance test plans and data requirements,” Pacific Northwest National Laboratory,
            Tech. Rep. PNNL-26492, Apr. 2017.
          </a>
        </li>
        <li id="ref-WuD13_storagetool" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1114904" target="_blank" rel="noreferrer">
            D. Wu, C. Jin, P. Balducci, and M. Kintner-Meyer, “Assessment of energy storage alternatives in the Puget
            Sound energy system–volume 2: Energy storage evaluation tool,” Pacific Northwest National Laboratory, Tech.
            Rep. PNNL-23039, Dec. 2013.
          </a>
        </li>
        <li id="ref-Baldu13" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.2172/1114900" target="_blank" rel="noreferrer">
            P. Balducci, C. Jin, D. Wu, M. Kintner-Meyer, P. Leslie, C. Daitch, and A. Marshall, “Assessment of energy
            storage alternatives in the Puget Sound Energy system–volume 1: Financial feasibility analysis,” Pacific
            Northwest National Laboratory, Tech. Rep. PNNL-23040, Dec. 2013.
          </a>
        </li>
      </ol>
    </div>
  );
}
